import { useNavigate, useLocation } from 'react-router-dom'
import { gameConfig } from '../config/gameConfig'
import './Header.css'

interface HeaderProps {
  onStatsClick?: () => void
  onShareClick?: () => void
  gameNumber?: number | null
  showShareButton?: boolean
}

function Header({ onStatsClick, onShareClick, gameNumber, showShareButton }: HeaderProps) {
  const navigate = useNavigate()
  const location = useLocation()
  const isPlayPage = location.pathname === '/play'
  const showBackButton = isPlayPage

  const handleBackClick = () => {
    navigate('/')
  }

const gameIcon = (() => {
  switch (gameConfig.dataSource) {
    case 'roster':
      return "/football-icon.svg"
    case 'running':
      return "/runner-icon.svg"
    default:
      return "/soccer-ball-icon.svg"
  }
})()

  return (
    <header className="app-header">
      <div className="header-content">
        {showBackButton ? (
          <button className="back-button" onClick={handleBackClick}>
            &lt;
          </button>
        ) : (
          <div className="header-spacer"></div>
        )}
        <div className="header-title-container">
          <img src={gameIcon} alt="Game Icon" className="header-icon" />
          <h1 className="header-title">{gameConfig.title}</h1>
          {gameNumber && <span className="game-number-header">#{gameNumber}</span>}
        </div>
        <div className="header-right">
          {showShareButton && (
            <button className="share-button-header" onClick={onShareClick} title="Share Your Result">
              📤
            </button>
          )}
          {onStatsClick && (
            <button className="stats-button-header" onClick={onStatsClick} title="View Statistics">
              📊
            </button>
          )}
        </div>
      </div>
    </header>
  )
}

export default Header
